import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./index.css";
import { registerIcons } from "./common/icons";
import ApiService from "./common/apiService.js";
import { SentryService } from "./common/sentryService";


ApiService.init();
SentryService.init(router);

const app = createApp(App);
registerIcons(app);
app.use(store).use(router).mount("#app");
